// @flow
import $ from 'jquery'
import _ from 'lodash'
import React, { Component, Fragment } from 'react'
import CampaignTableRow from './CampaignsTable/CampaignTableRow'
import FloatHeader from '../main/legacy/TableFloatHeader'
import AudienceTableRow from './CampaignsTable/AudienceTableRow'
import RenameCampaignForm from './CampaignsTable/RenameCampaignForm'
import CampaignFilterForm from './CampaignsTable/CampaignFilterForm'
import Thead from './CampaignsTable/Thead'
import { Table } from './MainTable'
import styled, { type StyledComponent } from 'styled-components'
import type { FilterParamsType } from './types'
import MassOperationsFooter from './controls/MassOperationsFooter'
import PriceBudgetFormContainer from './CampaignsTable/PriceBudgetFormContainer'
import Modal from './FieldSet/Modal'
import TableHeaders from './CampaignsTable/TableHeaders'
import postJson from '../services/postJson'
import { onlyStatisticHeaders } from './controls/groupHeaders'

const DelimiterRow: StyledComponent<Object, any, any> = styled.tr`
  height: 20px;
  border-top: 1px solid #d1d1d1;
`
const ContentWrapper = styled.div`
  overflow: auto;
  width: 100%;
`
const LoadingEstimatesMessage = styled.div`
  padding-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
`

const activateUrl = '/api/v1/audience_statuses/activate'
const deactivateUrl = '/api/v1/audience_statuses/deactivate'
const archiveUrl = '/api/v1/audience_statuses/archive'
export const priceBudgetUpdateUrl = '/api/v1/audiences/price_budget_update'
const createEstimatesUrl = '/api/v1/estimates'

type Props = {|
  locale: string,
  campaigns: Array<Object>,
  filterProps: Object,
  campaignList: Array<Object>,
  filteredCampaignList: Array<Object>,
  collapsedCampaignsIds: Array<number>,
  archivedAudienceIds: Array<number>,
  archivedCampaignIds: Array<number>,
  filterParams: FilterParamsType,
  onInit: Function,
  onChange: Function,
  onDatepickerChange: Function,
  checkedAudiencesIds: Array<number>,
  isLoading: boolean,
  isPriceBudgetModalOpen: boolean,
  isTableHeadersModalOpen: boolean,
  headers: Array<string>,
  selectedFields: Array<string>,
  currentFilterField: string,
  statisticsFilters: Array<Object>,
  initialIsLoadingEstimates: boolean,
  isLoadingEstimates: boolean
|}

const t = {
  loading_estimates:
    'Мы запустили сбор прогноза размера аудиторий, данные обновятся в течение 1-2 минут или быстрее (зависит от количества аудиторий)',
  price_budget_modal_header: 'Изменение бюджета/ставки аудиторий',
  statistic_fields_modal_header: 'Выбор столбцов со статистикой',
  statistic_filter_modal_header: 'Фильтрация по статистике'
}

const cookieDelimeter = '-'
const campaignCookieName = 'collapsed_campaigns'
const headersCookieName = 'table_headers'

const DEFAULT_HEADERS = [
  'status_checkbox',
  'campaign',
  'status',
  'advertisements',
  'budget',
  'payment',
  'users',
  'spent',
  'impressions',
  'clicks',
  'ctr',
  'average_cpc',
  'average_cpm',
  'goals',
  'goal_percentage',
  'goal_price',
  'modal_cog'
]

export default class CampaignsTable extends Component<Props> {
  table: any
  debouncedEstimatesRequest: any
  estimateAudienceIds: any

  constructor(props: Props) {
    super(props)

    const campaignCookie = window.Cookies.get(campaignCookieName)
    const headersCookie = window.Cookies.get(headersCookieName)
    const initial = {
      campaignList: props.campaigns,
      collapsedCampaignsIds: campaignCookie
        ? _.map(campaignCookie.split(cookieDelimeter), (s) => parseInt(s))
        : [],
      archivedAudienceIds: [],
      archivedCampaignIds: [],
      checkedAudiencesIds: [],
      headers: headersCookie ? _.map(headersCookie.split(cookieDelimeter)) : DEFAULT_HEADERS,
      isLoadingEstimates: props.initialIsLoadingEstimates
    }
    this.debouncedEstimatesRequest = _.debounce(this.requestEstimates, 1000)
    this.estimateAudienceIds = []
    props.onInit(initial)
  }

  render() {
    const { filterProps, filterParams } = this.props
    const { allCampaignOptions, filterFormOrigin, dateSeparator, initialDate } = filterProps

    return (
      <Fragment>
        <Modal
          maxWidth={500}
          header={t.price_budget_modal_header}
          isOpen={this.props.isPriceBudgetModalOpen}
          hideBtn
          onClose={() => this.props.onChange({ isPriceBudgetModalOpen: false })}
        >
          <PriceBudgetFormContainer
            onCloseModal={() => this.props.onChange({ isPriceBudgetModalOpen: false })}
            onUpdateAudienceState={(data, ids) => this.updateAudienceState(data, ids)}
          />
        </Modal>
        <Modal
          maxWidth={500}
          header={t.statistic_fields_modal_header}
          isOpen={this.props.isTableHeadersModalOpen}
          hideBtn
          onClose={() => this.props.onChange({ isTableHeadersModalOpen: false })}
        >
          <TableHeaders
            headers={this.props.headers}
            allHeaders={this.props.filterProps.tableHeaders}
            selectedFields={this.props.selectedFields}
            onChange={(headers) => {
              window.Cookies.set(headersCookieName, headers.join(cookieDelimeter))
              const statisticFilters = _.filter(
                this.props.filterParams.statisticFilters,
                (filter) => {
                  return _.includes(headers, filter.field)
                }
              )
              this.props.onChange({ filterParams: { ...filterParams, statisticFilters } })
              this.props.onChange({ headers: headers })
            }}
            onApply={() => this.props.onChange({ isTableHeadersModalOpen: false })}
          />
        </Modal>
        <CampaignFilterForm
          campaignOptions={allCampaignOptions}
          filterFormOrigin={filterFormOrigin}
          dateSeparator={dateSeparator}
          initialDate={initialDate}
          filterParams={filterParams}
          statisticFields={_.intersection(this.props.selectedFields, onlyStatisticHeaders())}
          onChange={(filterParams) => this.props.onChange(filterParams)}
          onDatepickerChange={(filterParams, callback) =>
            this.props.onDatepickerChange(filterParams, callback)
          }
        />
        {this.props.isLoadingEstimates && (
          <LoadingEstimatesMessage className="t-LoadingEstimatesMessage">
            {t.loading_estimates}
          </LoadingEstimatesMessage>
        )}
        <RenameCampaignForm locale={this.props.locale} />
        <ContentWrapper>
          <Table
            ref={(el) => {
              this.table = el
            }}
            className="t-CampaignTable"
          >
            <Thead
              headers={this.props.headers}
              onCogClick={() => this.props.onChange({ isTableHeadersModalOpen: true })}
              onRefreshClick={() => {
                this.estimateAudienceIds = _.flatten(
                  _.map(this.props.filteredCampaignList, (campaign) => {
                    return _.compact(
                      _.map(campaign.audiences, (audience) => {
                        return audience.id
                      })
                    )
                  })
                )
                this.debouncedEstimatesRequest()
              }}
            />
            <tbody>
              {this.campaigns().map((campaign, index) => [
                index !== 0 && this.renderEmptyRow(),
                this.renderCampaignBlock(campaign)
              ])}
            </tbody>
          </Table>
        </ContentWrapper>
        {!_.isEmpty(this.fixedCheckedAudiencesIds()) && this.renderFooter()}
      </Fragment>
    )
  }

  renderCampaignBlock(campaign: Object): any {
    const isCollapsed = this.isCampaignCollapsed(campaign.id)

    return [
      <CampaignTableRow
        key={campaign.id}
        locale={this.props.locale}
        audiencesCount={this.campaignAudiences(campaign.id, campaign.audiences).length}
        advertisementsCount={_.sum(
          _.map(this.campaignAudiences(campaign.id, campaign.audiences), 'advertisementsCount')
        )}
        isCollapsed={isCollapsed}
        onArchive={() => this.campaignArchived(campaign.id)}
        onArchivationRollback={() => this.campaignArchivationFailed(campaign.id)}
        onCollapse={(isCollapsed) => this.campaignCollapsed(campaign.id, isCollapsed)}
        campaignCheckboxChecked={this.isCampaignCheckboxChecked(campaign)}
        onCampaignCheckboxChange={(checked) => this.campaignCheckboxChange(checked, campaign)}
        isFirstCampaign={_.first(this.campaigns()) === campaign}
        isLastInGroup={
          isCollapsed || _.isEmpty(this.campaignAudiences(campaign.id, campaign.audiences))
        }
        selectedFields={this.props.selectedFields}
        {...campaign}
      />,
      !isCollapsed &&
        this.campaignAudiences(campaign.id, campaign.audiences).map((audience, index) => (
          <AudienceTableRow
            key={audience.id}
            locale={this.props.locale}
            onArchive={() => this.audienceArchived(audience.id)}
            onArchivationRollback={() => this.audienceArchivationFailed(audience.id)}
            audienceCheckboxChecked={this.isAudienceCheckboxChecked(audience)}
            onAudienceCheckboxChange={(checked) => this.audienceCheckboxChange(checked, audience)}
            onAudienceStateChange={(data) => {
              this.updateAudienceState(data, [audience.id])
            }}
            isLastInGroup={
              index === this.campaignAudiences(campaign.id, campaign.audiences).length - 1
            }
            activateUrl={activateUrl}
            deactivateUrl={deactivateUrl}
            archiveUrl={archiveUrl}
            selectedFields={this.props.selectedFields}
            {...audience}
          />
        ))
    ]
  }

  renderEmptyRow() {
    return (
      <DelimiterRow key={0}>
        <td colSpan={this.props.headers.length} />
      </DelimiterRow>
    )
  }

  campaigns(): Array<Object> {
    return _.filter(
      this.props.filteredCampaignList,
      (campaign) => !_.includes(this.props.archivedCampaignIds, campaign.id)
    )
  }

  campaignAudiences(campaignId: string, audiences: Array<Object>): Array<Object> {
    return _.filter(
      audiences,
      (audience) =>
        !_.includes(this.props.archivedAudienceIds, audience.id) &&
        !_.includes(this.props.archivedCampaignIds, campaignId)
    )
  }

  isCampaignCollapsed(campaignId: number) {
    return _.includes(this.props.collapsedCampaignsIds, campaignId)
  }

  campaignCollapsed(campaignId: number, isCollapsed: boolean) {
    let collapsedCampaignsIds = isCollapsed
      ? _.uniq(_.concat(this.props.collapsedCampaignsIds, campaignId))
      : _.without(this.props.collapsedCampaignsIds, campaignId)

    window.Cookies.set(campaignCookieName, collapsedCampaignsIds.join(cookieDelimeter))

    this.props.onChange({ collapsedCampaignsIds })
  }

  campaignArchived(id: number) {
    this.props.onChange({
      archivedCampaignIds: _.concat(this.props.archivedCampaignIds, id)
    })
  }

  campaignArchivationFailed(id: number) {
    this.props.onChange({
      archivedCampaignIds: _.without(this.props.archivedCampaignIds, id)
    })
  }

  audienceArchived(id: number) {
    this.props.onChange({
      archivedAudienceIds: _.concat(this.props.archivedAudienceIds, id)
    })
  }

  audienceArchivationFailed(id: number) {
    this.props.onChange({
      archivedAudienceIds: _.without(this.props.archivedAudienceIds, id)
    })
  }

  componentDidMount() {
    new FloatHeader($(this.table)) // eslint-disable-line no-new
  }

  isCampaignCheckboxChecked(campaign: Object) {
    if (_.isEmpty(campaign.audiences)) return false

    return _.every(campaign.audiences, (audience) => {
      return this.isAudienceCheckboxChecked(audience)
    })
  }

  isAudienceCheckboxChecked(audience: Object) {
    return _.includes(this.props.checkedAudiencesIds, audience.id)
  }

  allAudiencesIds(): Array<number> {
    const { filteredCampaignList } = this.props
    return _.flatten(
      _.map(filteredCampaignList, (campaign) => {
        return _.map(campaign.audiences, (audience) => {
          return audience.id
        })
      })
    )
  }

  campaignCheckboxChange(checked: boolean, campaign: Object) {
    const { checkedAudiencesIds, onChange } = this.props
    const audiencesIds = _.map(campaign.audiences, (audience) => {
      return audience.id
    })

    if (checked) {
      onChange({ checkedAudiencesIds: checkedAudiencesIds.concat(audiencesIds) })
    } else {
      onChange({
        checkedAudiencesIds: _.without.apply(_, [checkedAudiencesIds].concat(audiencesIds))
      })
    }
  }

  audienceCheckboxChange(checked: boolean, audience: Object) {
    const { checkedAudiencesIds, onChange } = this.props

    if (checked) {
      onChange({ checkedAudiencesIds: checkedAudiencesIds.concat(audience.id) })
    } else {
      onChange({ checkedAudiencesIds: _.without(checkedAudiencesIds, audience.id) })
    }
  }

  fixedCheckedAudiencesIds(): Array<number> {
    const { checkedAudiencesIds } = this.props
    return _.intersection(this.allAudiencesIds(), checkedAudiencesIds)
  }

  renderFooter() {
    return (
      <MassOperationsFooter
        isLoading={this.props.isLoading}
        activateUrl={activateUrl}
        deactivateUrl={deactivateUrl}
        archiveUrl={archiveUrl}
        ids={this.fixedCheckedAudiencesIds()}
        onBeforeRequest={() => this.props.onChange({ isLoading: true })}
        onAfterRequest={() => this.props.onChange({ isLoading: false })}
        onActivateDeactivateSuccess={(data, ids) => this.updateAudienceState(data, ids)}
        onArchiveSuccess={() => this.onArchiveSuccess()}
        onPriceBudgetEdit={() => this.props.onChange({ isPriceBudgetModalOpen: true })}
      />
    )
  }

  updateAudienceState(data: Array<Object>, ids: Array<number>) {
    const { campaignList, onChange } = this.props
    const newCampaignList = _.map(campaignList, (campaign) => {
      const newAudiences = _.map(campaign.audiences, (audience) => {
        if (!_.includes(ids, audience.id)) return audience

        const newAudienceState = _.find(data, (state) => {
          return state.id === audience.id
        })
        return newAudienceState
          ? {
              ...audience,
              active: newAudienceState.active,
              checked: newAudienceState.state,
              humanState: newAudienceState.human_state,
              stateValue: newAudienceState.state_value,
              price: newAudienceState.price,
              budget: newAudienceState.budget,
              budget_cycle: newAudienceState.budget_cycle,
              payment_type: newAudienceState.payment_type,
              total_limit: newAudienceState.total_limit,
              name: newAudienceState.name
            }
          : audience
      })
      const budget = _.sum(
        _.map(newAudiences, (audience) => {
          return parseFloat(audience.budget.replace(' ', ''))
        })
      ).toLocaleString('ru-RU')
      const totalLimit = _.sum(
        _.compact(
          _.map(newAudiences, (audience) => {
            return audience.total_limit && parseFloat(audience.total_limit.replace(' ', ''))
          })
        )
      ).toLocaleString('ru-RU')
      return {
        ...campaign,
        budget: budget,
        totalLimit: totalLimit,
        audiences: newAudiences
      }
    })
    onChange({ campaignList: newCampaignList })
  }

  onArchiveSuccess() {
    const { archivedAudienceIds, onChange } = this.props
    const fixedCheckedAudiencesIds = this.fixedCheckedAudiencesIds()
    onChange({
      archivedAudienceIds: archivedAudienceIds.concat(fixedCheckedAudiencesIds),
      checkedAudiencesIds: []
    })
  }

  requestEstimates() {
    const { campaignList, onChange } = this.props
    const items = _.map(this.estimateAudienceIds, (id) => {
      return { type: 'audience', audience_id: id }
    })

    if (_.isEmpty(items)) return

    onChange({ isLoadingEstimates: true })
    postJson(createEstimatesUrl, { items: items })
      .done((estimates) => {
        const ready = _.every(estimates, (estimate) => {
          return estimate.ready
        })
        if (ready) {
          onChange({ isLoadingEstimates: false })
          const newCampaignList = _.map(campaignList, (campaign) => {
            return {
              ...campaign,
              audiences: _.map(campaign.audiences, (audience) => {
                if (!_.includes(this.estimateAudienceIds, audience.id)) return audience
                const audienceEstimates = _.find(estimates, (estimate) => {
                  return _.isEqual(estimate.audience_id, audience.id)
                })
                return {
                  ...audience,
                  estimates: audienceEstimates || audience.estimates
                }
              })
            }
          })
          onChange({ campaignList: newCampaignList })
        } else {
          this.debouncedEstimatesRequest()
        }
      })
      .fail(() => {
        onChange({ isLoadingEstimates: false })
        console.log('internal error')
      })
  }
}
